import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import './App.css';
import Navigation from './Navigation';
import Home from './Home';
import About from './About';
import Nuclei from '../containers/Nuclei';
import SingleCell from './SingleCell';
import Download from './Download';
import Footer from './Footer';
import NoMatch from './NoMatch';

class App extends Component {
  render() {
    return (
      <Router>
        <div className="App">
          <Navigation />
          <Switch>
            <Redirect exact from="/nuclei" to="/nuclei/barplot" />
            <Route exact path="/" component={Home} />
            <Route path="/about" component={About} />
            <Route path="/nuclei" component={Nuclei} />
            <Route path="/download" component={Download} />
            <Redirect exact from="/single-cell" to="/single-cell/violin" />
            <Route path="/single-cell" component={SingleCell} />
            <Route component={NoMatch} />
          </Switch>
          <Footer />
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.jsx